import getApp from './qapp';
var Promise = require("bluebird");

export default new Promise((resolve) => {
  $.getJSON('https://api.ipify.org?format=json', data => {
    let [firstOctet,secondOctet,thirdOctet,fourthOctet] = data.ip.split(".").map(num => { return Number(num); });
    let ip = (firstOctet * Math.pow(256,3)) + (secondOctet * Math.pow(256,2)) + (thirdOctet * 256) + (fourthOctet);
    getApp.then(app => {
      app.createCube({
        qDimensions: [{
          qDef: {
            qFieldDefs: [`City_St`]
          }
        },{
          qDef: {
            qFieldDefs: [`network_start_integer`]
          }
        }],
        qMeasures: [{
          qDef: {
            qDef: `if(network_start_integer < ${ip} and network_last_integer > ${ip}, 1)`
          }
        }],
        qSuppressZero: true,
        qSuppressMissing: true,
        qInitialDataFetch: [{
          qWidth: 1,
          qHeight: 1
        }]
      }).then(model => {
        let matrix = model.layout.qHyperCube.qDataPages[0].qMatrix;
        if (matrix.length > 0) {
          model.selectHyperCubeValues('/qHyperCubeDef', 0, [matrix[0][0].qElemNumber], false);
          resolve();
        } else {
          $("#load-screen-msg").html("Could not find your location in our dataset. Defaulting to Chicago, Illinois");
          setTimeout(() => {
            model.selectHyperCubeValues("/qHyperCubeDef", 0, [9469], false);
            resolve(); 
          }, 1000);
        }
      });
    });
  }).fail(() => {
    $("#load-screen-msg").html("Could not detect your location. Defaulting to Chicago, Illinois");
    setTimeout(() => {
      getApp.then(app => {
        app.field('City_St').select([9469], false);
        resolve();
      })
    }, 1000);
  });
});


// WEBPACK FOOTER //
// ./locate.js